module.exports = __webpack_public_path__ + "336f044e2333aca132cf00c53760b116.png";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/MCA_white_400px.png
// module id = 857
// module chunks = 0